import {useState, useCallback, useMemo} from "react";
import {useKeycloakFunctions} from "./useKeycloakFunctions";
import {nimbusAPI} from "../common/api/nimbusAPI";

export const useNimbus = () => {
    const {initialized, keycloak} = useKeycloakFunctions();

    const [loginRedirectUri, setLoginRedirectUri] = useState();
    const [loadingLogin, setLoadingLogin] = useState(false);
    const [errorLogin, setErrorLogin] = useState();

    const login = useCallback(async () => {
        if (initialized && keycloak?.authenticated) {
            try {
                setLoadingLogin(true);
                setErrorLogin(null);
                const loginRes = await nimbusAPI.post("/oidc/login", {}, {headers: {"X-ID-Token": keycloak.idToken}});
                setLoginRedirectUri(loginRes?.data?.redirect_uri);
            }
            catch (e) {
                setErrorLogin(e.response);
                throw e.response;
            }
            finally {
                setLoadingLogin(false);
            }
        }
    }, [initialized, keycloak?.authenticated, loginRedirectUri]);

    const memoedVal = useMemo(() => ({
        login,
        loginRedirectUri,
        loadingLogin,
        errorLogin
    }), [
        login,
        loginRedirectUri,
        loadingLogin,
        errorLogin
    ]);

    return memoedVal;
};
